import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/settings/_access/sources/$sourceId/')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/settings/sources/$sourceId/$tab',
      params: { organizationName: params.organizationName, sourceId: params.sourceId, tab: 'users' },
    });
  },
});
